import { PinwheelScreens } from './PinwheelScreens';

export const pinwheelScreenNameMap: Record<PinwheelScreens, string> = {
  [PinwheelScreens.SEARCH_DEFAULT]: 'Pinwheel Search Default',
  [PinwheelScreens.SEARCH_RESULTS]: 'Pinwheel Search Results',
  [PinwheelScreens.SEARCH_PLATFORM_ONLY]: 'Pinwheel Search Platform Only',
  [PinwheelScreens.PROVIDER_CONFIRMATION]: 'Pinwheel Provider Confirmation',
  [PinwheelScreens.LOGIN]: 'Pinwheel Login',
  [PinwheelScreens.DD_AMOUNT_SELECTION]: 'Pinwheel DD Amount Selection',
  [PinwheelScreens.DD_CONFIRMATION]: 'Pinwheel DD Confirmation',
  [PinwheelScreens.JOB_SUCCESS]: 'Pinwheel Job Success',
  [PinwheelScreens.JOB_ERROR]: 'Pinwheel Job Error',
  [PinwheelScreens.MANUAL_INSTRUCTIONS]: 'Pinwheel Manual Instructions',
  [PinwheelScreens.BILL_SWITCH_INTRO]: 'Pinwheel Bill Switch Intro',
  [PinwheelScreens.BILL_SWITCH_ACCOUNTS]: 'Pinwheel Bill Switch Accounts',
  [PinwheelScreens.BILL_SWITCH_MERCHANT_LIST]:
    'Pinwheel Bill Switch Merchant List',
  [PinwheelScreens.BILL_SWITCH_MERCHANT]: 'Pinwheel Bill Switch Merchant',
  [PinwheelScreens.PLAID_MODAL]: 'Pinwheel Plaid Modal',
  [PinwheelScreens.RECURRENCES_FOUND]: 'Pinwheel Recurrences Found',
  [PinwheelScreens.BILL_SWITCH_MANUAL]: 'Pinwheel Bill Switch Manual',
  [PinwheelScreens.BILL_SWITCH_PAYMENT_METHOD]:
    'Pinwheel Bill Switch Payment Method',
  [PinwheelScreens.BILL_SWITCH_TRANSACTIONS]:
    'Pinwheel Bill Switch Transactions',
  [PinwheelScreens.BILL_SWITCH_SUCCESS]: 'Pinwheel Bill Switch Success',
  [PinwheelScreens.BILL_SWITCH_FAILURE]: 'Pinwheel Bill Switch Failure',
  [PinwheelScreens.BILL_CANCEL_MANUAL]: 'Pinwheel Bill Cancel Manual',
  [PinwheelScreens.BILL_CANCEL_MERCHANT]: 'Pinwheel Bill Cancel Merchant',
  [PinwheelScreens.BILL_MANAGER_ACCOUNTS]: 'Pinwheel Bill Manager Accounts',
  [PinwheelScreens.BILL_MANAGER_CALENDAR]: 'Pinwheel Bill Manager Calendar',
  [PinwheelScreens.BILL_MANAGER_CALENDAR_SYNC]:
    'Pinwheel Bill Manager Calendar Sync',
  [PinwheelScreens.BILL_MANAGER_DASHBOARD]: 'Pinwheel Bill Manager Dashboard',
  [PinwheelScreens.BILL_MANAGER_INTRO]: 'Pinwheel Bill Manager Intro',
  [PinwheelScreens.BILL_MANAGER_LIST]: 'Pinwheel Bill Manager List',
  [PinwheelScreens.BILL_MANAGER_RECURRENCE]: 'Pinwheel Bill Manager Recurrence',
  [PinwheelScreens.BILL_MANAGER_RECURRENCE_ADD]:
    'Pinwheel Bill Manager Recurrence Add',
  [PinwheelScreens.BILL_MANAGER_RECURRENCE_EDIT]:
    'Pinwheel Bill Manager Recurrence Edit',
  [PinwheelScreens.BILL_MANAGER_SUPPORT]: 'Pinwheel Bill Manager Support',
  [PinwheelScreens.EXIT_CONFIRMATION]: 'Pinwheel Exit Confirmation',
};
